import { TERMS_CONDITIONS_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TTermsConditionsSelector, TEqualityFunction } from '../types';

export const useTermsConditionsSelector =
    <TSelected>(selector: TTermsConditionsSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
        return useCustomSelector<TSelected, typeof TERMS_CONDITIONS_REDUCER>(TERMS_CONDITIONS_REDUCER, selector, equalityFn);
    };
